(function () {
    App.filter('preparePersonsList', preparePersonsList);
    preparePersonsList.$inject = [];

    function preparePersonsList() {
        return function (declarationData) {
            if (!declarationData) return [];
            var toReturn = [];

            if (declarationData.person) toReturn.push(declarationData.person);
            if (declarationData.partner) toReturn.push(declarationData.partner);

            toReturn = toReturn.concat(declarationData.children);

            return toReturn
        }
    }
})();
